import { Client } from 'fourpda-api';
import { WebSocketTransport } from 'fourpda-api/browser';

export const transport = new WebSocketTransport(true);
export const client = new Client(transport);

export async function ensureConnected() {
  if (!transport.isConnected()) {
    await transport.connect();
  }
  await client.auth.handshake();
}
